<div class="c-page-employeegeneral"> </div>
      <div class="container u-pb60">
        <div class="row mobile--orange u-pt30">
          <div class="col-md-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                 <li class="breadcrumb-item"><a  [routerLink]="['/']"> {{'ExceptionAccessPortal.home' | translate}}</a></li>
                <li class="breadcrumb-item active" aria-current="page"> &nbsp; -&nbsp;  </li><span class="js-txt2">{{'ExceptionAccessPortal.location' | translate}}</span>
              </ol>
            </nav>
            <h2 class="o-title js-txt3">{{'ExceptionAccessPortal.title' | translate}}</h2>
            <p class="o-text js-txt4">{{ 'ExceptionAccessPortal.titleDescription' | translate}}</p>
          </div>
        </div>
        <form class="o-form"[formGroup]="formAccessEmployee" >
          <div class="row u-pt20">
            <div class="col-md-12" id="siteSection">
              <h2 class="o-title o-title--medium o-title--orange js-txt5">{{'ExceptionAccessPortal.requestTitle' | translate}}</h2>
              <p class="o-text js-txt6">{{'ExceptionAccessPortal.requestSubtitle' | translate}}.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group u-pb20" >
                <label class="o-title o-title--label o-title--required ">{{'ExceptionAccessPortal.labelSite'| translate}}</label>
                <select name="site" class="o-form__select" required style="cursor:pointer" formControlName="siteId" (change)="changeSelectSite($event.target.value)" >
                    <option [value]="''" disabled selected>{{ 'ExceptionAccessPortal.selOption' | translate}}</option>
                    <option [value]="site.id" *ngFor="let site of site">{{site.name}}</option>
                </select>
                <div *ngIf="formAccessEmployee.controls['siteId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.selOneOption' | translate}}</mat-error></h5></span>
              </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group u-pb20">
                <label class="o-title o-title--label o-title--required">{{'ExceptionAccessPortal.labelZone'| translate}}</label>
                <!-- <span   class="ptooltip title--tooltip"  matTooltipPosition="right" matTooltip="{{'accessExceptionForm.tooltipZone'| translate}}">
                  ?
                </span> -->

                <select name="zone" class="o-form__select" required style="cursor:pointer" formControlName="zoneId" (change)="changeNotBuGetApprover($event.target.value)"
                            [attr.disabled]="formAccessEmployee.controls['siteId'].hasError('required') ? true : null"
                            bind-style.background-color="formAccessEmployee.controls['siteId'].hasError('required') ? '#F2F0E9' : ''"
                            bind-style.cursor="formAccessEmployee.controls['siteId'].hasError('required') ? 'no-drop' : ''" required >
                    <option [value]="''" disabled selected>{{ 'ExceptionAccessPortal.selOption' | translate}}</option>
                    <option [value]="zone.id" *ngFor="let zone of selectZone">{{zone.name}}</option>
                </select>

                <div *ngIf="formAccessEmployee.controls['zoneId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.selOneOption' | translate}}</mat-error></h5></span>
              </div>

              </div>
              </div>
            </div>
            <div class="row u-pb20 u-mb20">
              <div class="col-md-12 elementDiv " *ngIf="description!==null" >
                  <span class="elementSpan">{{description}}</span>
              </div>
            </div>
            <div class="row u-pb20 u-mb20">
              <div class="col-md-12 elementDiv " *ngIf="oneSapSite==='0000'" >
                <span class="elementSpan">{{ 'EmployeeAccessPortal.msgCas' | translate}}<i class="icon icon-close"></i></span>
              </div>
            </div>


          <div class="row u-pb20 u-mb20">
            <div class="col-md-12" id="subzoneQ">
              <label class="o-title o-title--label o-title--required js-txt48">{{'ExceptionAccessPortal.labelQuestion' | translate}}</label>
              <label class="o-text o-text--description js-txt13">{{'ExceptionAccessPortal.questionDescription' | translate}}</label>
              <div class="form-check-group">
                <div class="form-check" [formGroup]="RadioGroup">
                  <input class="form-check-input " id="exampleRadios5" type="radio" name="radioBtn" value="true" formControlName="radioBtn" required (change)="cleanSubzoneBU()" >
                  <label class="form-check-label" for="exampleRadios5">{{'ExceptionAccessPortal.optionYes' | translate}} </label>
                </div>
                <div class="form-check" [formGroup]="RadioGroup">
                  <input class="form-check-input" id="exampleRadios6" type="radio" name="radioBtn" value="false" formControlName="radioBtn" required  (change)="cleanSubzoneBU()">
                  <label class="form-check-label" for="exampleRadios6">{{'ExceptionAccessPortal.optionNo' | translate}} </label>
                </div>
              </div>
            </div>
           </div>


          <!--First approver-->
            <!--ZONE-->
            <div class="row" *ngIf="approverFacilityZone && approverFacilityZone.state && approverFacilityZone.priority===true && RadioGroup.value.radioBtn=='false'" >
              <div class="col-md-12">
                <label class="o-title o-title--label ">{{'ExceptionAccessPortal.firstApprover' | translate}}</label>
              </div>
              <div class="col-md-12" style="padding-bottom: 50px;"  >
                <p> <strong> {{ 'ExceptionAccessPortal.labelApproverName' | translate }}:</strong> {{approverFacilityZone.fullName}}</p>   <p><strong> {{ 'ExceptionAccessPortal.labelApproverPhone' | translate }}</strong>: {{approverFacilityZone.phone}}</p>   <p><strong> {{ 'ExceptionAccessPortal.labelApproverEmail' | translate }}:</strong> {{approverFacilityZone.email}}</p>
              </div>
            </div>

              <!--SUB-ZONE-->
            <div class="row" *ngIf="approverFacilitySubZone && approverFacilitySubZone.state && approverFacilitySubZone.priority===true && RadioGroup.value.radioBtn=='true'" >
              <div class="col-md-12">
                <label class="o-title o-title--label ">{{'ExceptionAccessPortal.firstApprover' | translate}}</label>
              </div>
              <div class="col-md-12" style="padding-bottom: 50px;"  >
                <p> <strong> {{ 'ExceptionAccessPortal.labelApproverName' | translate }}:</strong>  {{approverFacilitySubZone.labelApproverName}}</p>   <p><strong> {{ 'ExceptionAccessPortal.labelApproverPhone' | translate }}</strong>: {{approverFacilitySubZone.phone}}</p>   <p><strong> {{ 'ExceptionAccessPortal.labelApproverEmail' | translate }}:</strong>{{approverFacilitySubZone.email}}</p>
              </div>
            </div>
            <!-- ---------------------------------------- -->


           <div class="row" *ngIf="this.RadioGroup.value.radioBtn=='true'">

            <div class="col-md-6"  >
              <div class="form-group u-pb20">
                <label class="o-title o-title--label o-title--required" >{{'ExceptionAccessPortal.subzoneAccess' | translate}}</label>
                <span  class="ptooltip title--tooltip1"  matTooltipPosition="right" matTooltip="{{'ExceptionAccessPortal.tooltipSubZone'| translate}}" >
                  ?
              </span>
                <select name="subZone" class="o-form__select" required style="cursor:pointer" formControlName="subZoneId" (change)="getApproverSubZone($event.target.value)"
                    [attr.disabled]="formAccessEmployee.controls['zoneId'].hasError('required') ? true : null"
                    bind-style.background-color="formAccessEmployee.controls['zoneId'].hasError('required') ? '#F2F0E9' : ''"
                    bind-style.cursor="formAccessEmployee.controls['zoneId'].hasError('required') ? 'no-drop' : ''" required >
                    <option [value]="''" disabled selected>{{ 'ExceptionAccessPortal.selOption' | translate}}</option>
                    <option [value]="subZone.id" *ngFor="let subZone of selectSubZone">{{subZone.name}}</option>
                </select>
                <div *ngIf="selectSubZone.length===0 && !formAccessEmployee.controls['zoneId'].hasError('required')" style="width:100%; background-color: #F2F0E9" align="center">
                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.msgNotSubzone' | translate}}</mat-error></h5></span>
                </div>
                <div *ngIf="formAccessEmployee.controls['subZoneId'].hasError('required') && submited " style="width:100%; background-color: #F2F0E9" align="center">
                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.selOneOption' | translate}}</mat-error></h5></span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
                <div class="form-group u-pb30">
                  <label class="o-title o-title--label o-title--required js-txt18">{{'ExceptionAccessPortal.siteAccessApproverSubZone' | translate}}:
                    <!-- <div class="title--tooltip" data-toggle="tooltip" data-placement="top" title="Tooltip on top">?</div> -->
                  </label>


                  <!-- <select name="subZone" class="o-form__select" required style="cursor:pointer" formControlName="accessApproverId" 
                  [attr.disabled]="formAccessEmployee.controls['subZoneId'].hasError('required') ? true : null"
                  bind-style.background-color="formAccessEmployee.controls['subZoneId'].hasError('required') ? '#F2F0E9' : ''"
                  bind-style.cursor="formAccessEmployee.controls['subZoneId'].hasError('required') ? 'no-drop' : ''" required
                  >
                    <option [value]="''" disabled selected>{{ 'ExceptionAccessPortal.selOption' | translate}}</option>
                    <option [value]="approver.mdmid" *ngFor="let approver of approvers">{{approver.name }}</option>
                </select>
                <div *ngIf="approvers.length===0 && !formAccessEmployee.controls['subZoneId'].hasError('required')" style="width:100%; background-color: #F2F0E9" align="center">
                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.msgNotApprover' | translate}}</mat-error></h5></span>
                </div>
                <div *ngIf="formAccessEmployee.controls['accessApproverId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.selOneOption' | translate}}</mat-error></h5></span>
              </div> -->

            
            <div class="content-filter__group">
              <input *ngIf="formAccessEmployee.controls['subZoneId'].hasError('required')" 
                type="text" class="o-form__select" matInput [formControl]="toFormControl(formAccessEmployee.controls['accessApproverId'])" [matAutocomplete]="auto2"
                readonly="readonly"
                bind-style.background-color="formAccessEmployee.controls['subZoneId'].hasError('required') ? '#F2F0E9' : ''" 
                bind-style.cursor="formAccessEmployee.controls['subZoneId'].hasError('required') ? 'no-drop' : ''" required
              >
                <input *ngIf="!formAccessEmployee.controls['subZoneId'].hasError('required')" type="text" class="o-form__select" matInput [formControl]="toFormControl(formAccessEmployee.controls['accessApproverId'])"  [matAutocomplete]="auto2"
                [attr.disabled]="formAccessEmployee.controls['subZoneId'].hasError('required') ? true : null"
                bind-style.background-color="formAccessEmployee.controls['subZoneId'].hasError('required') ? '#F2F0E9' : ''"
                bind-style.cursor="formAccessEmployee.controls['subZoneId'].hasError('required') ? 'no-drop' : ''" required 
                >
                <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                  <mat-option *ngFor="let option of filteredOptionsApproverSubzone | async" [value]="option">
                    <span mat-raised-button 
                    aria-label="Button that displays a tooltip in various positions">
                    {{option.name}}
                    </span> <br>
                    <small style="color: #E65400">{{option.email}}</small>
                  </mat-option>
                </mat-autocomplete>
            </div>
            <div *ngIf="approvers.length===0 && !formAccessEmployee.controls['subZoneId'].hasError('required')" style="width:100%; background-color: #F2F0E9" align="center">
              <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.msgNotApprover' | translate}}</mat-error></h5></span>
          </div>
          <div *ngIf=" (formAccessEmployee.controls['accessApproverId'].value.mdmid==='' || formAccessEmployee.controls['accessApproverId'].value.mdmid===undefined ||formAccessEmployee.controls['accessApproverId'].value.mdmid===null) && submited" style="width:100%; background-color: #F2F0E9" align="center">
            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.selectOneOption' | translate}}</mat-error></h5></span>
            </div>







                </div>
              </div>

          </div>
          <div class="row u-pb20 u-mb20" style="padding-bottom: 15px;" *ngIf="this.RadioGroup.value.radioBtn=='true'">
            <div class="col-md-12 elementDiv" *ngIf="descriptionSubzone!==null" >
                <span class="elementSpan">{{descriptionSubzone}}</span>
            </div>

          </div>


          <div class="row" *ngIf="this.RadioGroup.value.radioBtn=='false'">
            <!-- quitar bu
              <div class="col-md-6">
              <div class="form-group u-pb20">
                <label class="o-title o-title--label o-title--required js-txt16">{{'accessExceptionForm.businessUnit' | translate}}:

                </label>
                <select name="subZone" class="o-form__select" required style="cursor:pointer" formControlName="bussinesUnitID" (change)="changeBuGetApprover($event.target.value)"
                [attr.disabled]="formAccessEmployee.controls['zoneId'].hasError('required') ? true : null"
                bind-style.background-color="formAccessEmployee.controls['zoneId'].hasError('required') ? '#F2F0E9' : 'white'"
                bind-style.cursor="formAccessEmployee.controls['zoneId'].hasError('required') ? 'no-drop' : ''"
                >
                    <option [value]="''" disabled selected>{{ 'ExceptionAccessPortal.selOption' | translate}}</option>
                    <option [value]="businessUnit.code" *ngFor="let businessUnit of selectBusiness">{{businessUnit.name}}</option>
                </select>
                <div *ngIf="formAccessEmployee.controls['bussinesUnitID'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.selOneOption' | translate}}</mat-error></h5></span>
              </div>
              </div>
            </div> -->
            <div class="col-md-6">
              <div class="form-group u-pb30">
                <label class="o-title o-title--label o-title--required js-txt18">{{'ExceptionAccessPortal.labelSiteApprover' | translate}}:
                  <!-- <div class="title--tooltip" data-toggle="tooltip" data-placement="top" title="Tooltip on top">?</div> -->
                </label>

                <div class="content-filter__group">
                  <input *ngIf="formAccessEmployee.controls['zoneId'].hasError('required')"
                    type="text" class="o-form__ie_select o-form__select" matInput [formControl]="ApproverId" [matAutocomplete]="auto"
                    readonly="readonly"
                    bind-style.background-color="formAccessEmployee.controls['zoneId'].hasError('required') ? '#F2F0E9' : ''"
                    bind-style.cursor="formAccessEmployee.controls['zoneId'].hasError('required') ? 'no-drop' : ''" required
                  >
                    <input *ngIf="!formAccessEmployee.controls['zoneId'].hasError('required')"
                           type="text" class="o-form__ie_select o-form__select" matInput [formControl]="ApproverId" [matAutocomplete]="auto"
                    [attr.disabled]="formAccessEmployee.controls['zoneId'].hasError('required') ? true : null"
                    bind-style.background-color="formAccessEmployee.controls['zoneId'].hasError('required') ? '#F2F0E9' : ''"
                    bind-style.cursor="formAccessEmployee.controls['zoneId'].hasError('required') || approvers.length===0 ? 'no-drop' : ''" required
                    >
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                        <span mat-raised-button
                        aria-label="Button that displays a tooltip in various positions">
                          {{option.name}}
                        </span> <br>
                        <small style="color: #E65400">{{option.email}}</small>
                      </mat-option>
                    </mat-autocomplete>
                    <div *ngIf="filteredOptions && approvers.length===0 && !formAccessEmployee.controls['zoneId'].hasError('required')" style="width:100%; background-color: #F2F0E9" align="center">
                      <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "> <i class="icon icon-close" style="margin-right: 5px;"></i>{{ 'ExceptionAccessPortal.msgNotApprover' | translate}}</mat-error></h5></span>
                    </div>
                </div>
                <!-- quitar bu
                  <select name="subZone" class="o-form__select" required style="cursor:pointer" formControlName="accessApproverId"
                [attr.disabled]="formAccessEmployee.controls['bussinesUnitID'].hasError('required') ? true : null"
                bind-style.background-color="formAccessEmployee.controls['bussinesUnitID'].hasError('required') ? '#F2F0E9' : ''"
                bind-style.cursor="formAccessEmployee.controls['bussinesUnitID'].hasError('required') ? 'no-drop' : ''" required
                >
                  <option [value]="''" disabled selected>{{ 'ExceptionAccessPortal.selOption' | translate}}</option>
                  <option [value]="approver.mdmid" *ngFor="let approver of approvers">{{approver.name }}</option>
              </select> -->
              <div *ngIf="this.RadioGroup.value.radioBtn === 'false' && (this.ApproverId.value.mdmid==='' || this.ApproverId.value.mdmid===undefined ||this.ApproverId.value.mdmid===null) && submited" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{ 'ExceptionAccessPortal.selOneOption' | translate}}</mat-error></h5></span>
            </div>
              </div>
            </div>
          </div>

            <!--APROVER FACILITY IF SECOND-->
            <!--ZONE-->
            <div class="row" *ngIf="approverFacilityZone && approverFacilityZone.state && approverFacilityZone.priority===false && RadioGroup.value.radioBtn=='false'">
              <div class="col-md-12">
                <label class="o-title o-title--label ">{{'ExceptionAccessPortal.secondApprover' | translate}}</label>
              </div>
              <div class="col-md-12" style="padding-bottom: 50px;"  >
                <p> <strong> {{ 'ExceptionAccessPortal.labelApproverName' | translate }}:</strong> {{approverFacilityZone.fullName}} </p>   <p><strong> {{ 'ExceptionAccessPortal.labelApproverPhone' | translate }}</strong>: {{approverFacilityZone.phone}}</p>   <p><strong> {{ 'ExceptionAccessPortal.labelApproverEmail' | translate }}:</strong>{{approverFacilityZone.email}}</p>
              </div>

            </div>
            <!--SUB-ZONE-->
            <div class="row" *ngIf="approverFacilitySubZone && approverFacilitySubZone.state && approverFacilitySubZone.priority===false && RadioGroup.value.radioBtn=='true'">
              <div class="col-md-12">
                <label class="o-title o-title--label ">{{'ExceptionAccessPortal.secondApprover' | translate}}</label>
              </div>
              <div class="col-md-12" style="padding-bottom: 50px;"  >
                <p> <strong> {{ 'ExceptionAccessPortal.labelApproverName' | translate }}:</strong> {{approverFacilitySubZone.labelApproverName}}</p>   <p><strong> {{ 'ExceptionAccessPortal.labelApproverPhone' | translate }}</strong>: {{approverFacilitySubZone.phone}}</p>   <p><strong> {{ 'ExceptionAccessPortal.labelApproverEmail' | translate }}:</strong>{{approverFacilitySubZone.email}}</p>
              </div>

            </div>
            <!-- ---------------------------------------- -->
          <div class="row" id="dateFormMAT">
            <div class="col-md-4 col-sm-6">

              <div class="form-group" >
                <label class="o-title o-title--required o-title--label ">{{'ExceptionAccessPortal.labelFrom' | translate}}</label>
                <mat-form-field  style="width: 100%;" appearance="standard">

                  <input matInput [min]="todayDate" onkeydown="return false" [max]="maxDate" [attr.disabled]="formAccessEmployee.controls['accessApproverId'].hasError('required') ? true : null" [matDatepicker]="picker" formControlName="dateStart" value="date" (dateChange)="clearPersonDate()">
                  <mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker  #picker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="formAccessEmployee.controls['dateStart'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'ExceptionAccessPortal.warn' | translate}}</mat-error></h5></span>
                </div>
              </div>

            </div>
            <div class="col-md-4 col-sm-6" >
              <div class="form-group" *ngIf="formAccessEmployee.controls['dateIndefinite'].value==false">
                <label class="o-title o-title--required o-title--label ">{{'ExceptionAccessPortal.labelTo' | translate}}</label>
                <mat-form-field style="width: 100%;" appearance="standard">
                  <input  matInput [min]="formAccessEmployee.controls.dateStart.value" onkeydown="return false" [max]="maxDateTo"  [matDatepicker]="picker2" formControlName="dateEnd" value="date" (dateChange)="dataEntry=null">
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>

                <div *ngIf="formAccessEmployee.controls['dateEnd'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'ExceptionAccessPortal.warn' | translate}}</mat-error></h5></span>
                </div>

                <div *ngIf="validationCep60001day()" style="width:100%; background-color: #F2F0E9" align="center">
                  <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'ExceptionAccessPortal.warnOneDayZone' | translate}}</mat-error></h5></span>
                </div>
              </div>
              <div class="form-group"  >
                <label class="o-title o-title--required o-title--label " *ngIf="formAccessEmployee.controls['dateIndefinite'].value==true">{{'ExceptionAccessPortal.labelTo' | translate}}</label>
                <div class="o-form__checkbox u-mb20" style="margin-top: 11px;">
                    <input type="checkbox" value="value" (change)="changeLimitDate()" formControlName="dateIndefinite" name="ConfirmDate" required><span></span>
                    <p class="open_modal"  >{{'ExceptionAccessPortal.undefinedAccess' | translate}}</p>
                </div>
            </div>

            </div>

          </div>
          <!-- 48 hours -->
          <div *ngIf="validation48hours()" style="margin-bottom: 15px;width:100%; background-color: #F2F0E9" align="center">
            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; ">
              <i class="icon icon-warning"></i> {{'ExceptionAccessPortal.warn48hrs' | translate}}</mat-error></h5></span>
          </div>

          <div *ngIf="controlDateAddError && (formAccessEmployee.controls['dateStart'].hasError('required') || formAccessEmployee.controls['dateEnd'].hasError('required'))" style="width:100%; background-color: #F2F0E9" align="center">
            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'ExceptionAccessPortal.warn' | translate}}</mat-error></h5></span>
         </div>

          <div class="row">
            <div class="col-md-12">
              <label class="o-title o-title--label js-txt25">{{'ExceptionAccessPortal.accessPurpose' | translate}}</label>
              <textarea class="o-form__textarea " placeholder=" {{'ExceptionAccessPortal.placeholderDescribe' | translate}}" formControlName="purpuse"
              [attr.disabled]="formAccessEmployee.controls['dateEnd'].hasError('required') ? true : null"
                bind-style.background-color="formAccessEmployee.controls['dateEnd'].hasError('required') ? '#F2F0E9' : 'white'"
                bind-style.cursor="formAccessEmployee.controls['dateEnd'].hasError('required') ? 'no-drop' : ''"



              ></textarea>
            </div>
          </div>
          <div class="hr orange u-mt40"></div>
          <div class="row u-pt40">
            <div class="col-md-12">
              <h2 class="o-title o-title--medium o-title--orange js-txt28">{{'ExceptionAccessPortal.titleInformation' | translate}}</h2>
            </div>
            <div class="col-md-12 u-pt20">
              <div class="o-etable">
                <div class="o-etable__employee">
                  <div class="row">
                    <div class="col-md-1 col-xs-2 col-md-offset-0">
                      <p> <strong>{{'ExceptionAccessPortal.colNumber' | translate}}</strong></p>
                    </div>
                    <div class="col-md-1 col-xs-2 col-md-offset-0 col-xs-offset-0">
                      <p class="u-hide__desktop">
                         <strong>{{'ExceptionAccessPortal.colType' | translate}}</strong></p>
                    </div>
                    <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-0">
                      <p class="u-show__mobile">
                        <strong>{{'ExceptionAccessPortal.colDetails' | translate}}</strong></p>
                      <p class="u-hide__desktop">
                        <strong>RUT/{{'ExceptionAccessPortal.colPassport' | translate}}</strong></p>
                    </div>
                    <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                      <p class="u-hide__desktop"> <strong>{{'ExceptionAccessPortal.colName' | translate}}</strong></p>
                    </div>
                    <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                      <p class="u-hide__desktop"> <strong>{{'ExceptionAccessPortal.colEmail' | translate}}</strong></p>
                    </div>
                    <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p class="u-hide__desktop"> <strong>{{'ExceptionAccessPortal.colCompany' | translate}}</strong></p>
                      </div>
                      <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p class="u-hide__desktop"> <strong> {{'ExceptionAccessPortal.colAction' | translate}} </strong></p>
                    </div>
                  </div>
                </div>

                <div  class="o-etable__employee "  *ngIf="!dataEntry">
                  <div class="row">
                    <div class="col-md-12 col-md-offset-1">
                      <p >{{'ExceptionAccessPortal.noDataEntry' | translate}}</p>
                    </div>
                  </div>
              </div>
                <div class="o-etable--body parent_etable"  *ngIf="dataEntry">
                  <div class="o-etable__employee "> <!--a class="btn-remove_clone_employee" ></a>-->
                    <div class="row"  >
                      <div class="col-md-1 col-xs-2">
                        <p><span>1</span></p>
                      </div>
                      <div align="center"
                          class="col-md-1 col-xs-2 col-md-offset-0 col-xs-offset-0">
                        <p>
                          <span bind-style.color="dataEntry.status === 0 ? 'green' : 'red'"
                          *ngIf="dataEntry.passportNumber">{{'ExceptionAccessPortal.colPassport' | translate}}</span>
                          <span
                              bind-style.color="dataEntry.status === 0 ? 'green' : 'red'"
                              *ngIf="dataEntry.passportNumber && dataEntry.nationalId"> / </span>
                              <span style="margin-right: 250px;"
                                  bind-style.color="dataEntry.status === 0 ? 'green' : 'red'"
                                  *ngIf="dataEntry.nationalId">{{'ExceptionAccessPortal.labelRUT' | translate}}</span>
                          </p>
                      </div>
                      <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p><span *ngIf="dataEntry.passportNumber">{{dataEntry.passportNumber}}</span><span *ngIf="dataEntry.passportNumber && dataEntry.nationalId"> / </span> <span *ngIf="dataEntry.nationalId">{{dataEntry.nationalId}}</span></p>
                      </div>
                      <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p>{{dataEntry.fullName}}</p>
                      </div>
                      <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" title="{{dataEntry.email}}">
                        {{dataEntry.email}}
                      </div>
                      <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p class="u-limit_width">{{dataEntry.companyName}}</p>
                      </div>
                      <div align="center" class="col-md-1 col-xs-12 col-md-offset-0 col-xs-offset-0">
                        <button (click)="this.dataEntry = null" style="border: 0; background-color: transparent;">
                            <svg class="bi bi-x" width="2em" height="2em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M5.646 5.646a.5.5 0 000 .708l8 8a.5.5 0 00.708-.708l-8-8a.5.5 0 00-.708 0z" clip-rule="evenodd"></path>
                                <path fill-rule="evenodd" d="M14.354 5.646a.5.5 0 010 .708l-8 8a.5.5 0 01-.708-.708l8-8a.5.5 0 01.708 0z" clip-rule="evenodd"></path>
                          </svg>
                        </button>
                    </div>
                      <div class="col-md-12 col-xs-12">
                        <!--<h6 *ngIf="dataEntry.status===0 "><i class="icon icon-check"></i><span class="js-txt33">Valido para solicitar una exception.</span></h6>-->
                       <!-- <h6 *ngIf="employee.status===1"><i class="icon icon-arrow"></i><span class="js-txt34">Doesn’t meet the qualifications of the selected site.</span><a class="open_modal "   style="float: right; color: #C52D10;" (click)="seeQualifications(employee.qualifications)" >Qualifications Status</a></h6>-->
                        <h6 *ngIf="dataEntry.status===1 "><i class="icon icon-close"></i>
                          <p *ngIf="!isMandatory()" class="js-txt34">{{'ExceptionAccessPortal.msgAnotherForm'| translate}}
                            <a style="padding-left:25px; color: #C52D10; cursor: pointer;" (click)="seeQualifications(dataEntry.qualifications)">{{'ExceptionAccessPortal.labelStatus' | translate}}</a></p>
                          <p *ngIf="isMandatory()" class="js-txt34">{{'ExceptionAccessPortal.msgFormMandatory'| translate}}
                            <a *ngIf="dataEntry.qualifications "class="open_modal "   style="padding-left:25px; color: #C52D10; cursor: pointer;" (click)="seeQualifications(dataEntry.qualifications)">{{'ExceptionAccessPortal.labelStatus' | translate}}</a></p>
                        </h6>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="o-etable__employee o-etable__employee--action" style="background-color: #F2F0E9;" *ngIf="!dataEntry">
                  <div class="row"  *ngIf="!this.formRadio.value.document || this.formRadio.value.document==='nationalId' ">


                    <div class="col-md-2 col-md-offset-1">
                      <h5>
                        <div class="js-txt29">{{'ExceptionAccessPortal.dataEntry' | translate}}</div><span class="js-txt30">{{'ExceptionAccessPortal.dataException' | translate}}</span>
                      </h5>
                    </div>
                    <form class="o-form" [formGroup]="formRadio" >
                        <div class="col-md-2 col-md-offset-0">


                            <label style="cursor:pointer; padding-bottom: 5px;">
                                <input class="form-check-input" type="radio" formControlName="document" value="nationalId" id="nationalId" style="cursor:pointer"> {{'ExceptionAccessPortal.labelRUT' | translate}} <br>
                            </label><br>
                            <label style="cursor:pointer;">
                                <input class="form-check-input" type="radio" formControlName="document" value="passportNumber" id="passportNumber" style="cursor:pointer"> {{'ExceptionAccessPortal.labelPassport' | translate}}
                            </label>
                            <label><mat-error *ngIf="formRadio.controls['document'].hasError('required') && radioPress"> {{'ExceptionAccessPortal.labelDocumentType' | translate}} </mat-error></label>

                        </div>
                        <div class="col-md-3 col-md-offset-2">

                            <div class="o-etable__addemployee">

                                <input style="background-color: white;" class="o-form__input" formControlName="ID" type="text" placeholder="RUT">
                                <mat-error *ngIf="formRadio.controls['ID'].hasError('validateRUN')">
                                  <i class="icon icon-close" ></i> {{'ExceptionAccessPortal.notValidRut' | translate}} {{'ExceptionAccessPortal.rutExample' | translate}}
                                </mat-error>

                            </div>
                            <mat-error *ngIf="formRadio.controls['ID'].hasError('required') && radioPress "> {{'ExceptionAccessPortal.RequiredRutpass' | translate}} </mat-error>
                        </div>
                        <div class="col-md-2"><a (click)="add()" class="btn btn--primary" id="clone-add_employee" >{{'ExceptionAccessPortal.btnAdd'  | translate }}</a></div>
                    </form>
                  </div>

                  <!-- Agrupar cod para select -->
                  <div class="row"  *ngIf="this.formRadio.value.document==='passportNumber' ">


                    <div class="col-md-2 col-md-offset-1" >
                      <h5>
                        <div class="js-txt29">{{'ExceptionAccessPortal.dataEntry' | translate}}</div>
                            <span class="js-txt30">{{'ExceptionAccessPortal.dataException' | translate}}</span>
                      </h5>
                    </div>
                    <form class="o-form" [formGroup]="formRadio" >
                        <div class="col-md-2 col-md-offset-0" >


                            <label style="cursor:pointer; padding-bottom: 5px;">
                                <input class="form-check-input" type="radio" formControlName="document" value="nationalId" id="nationalId" style="cursor:pointer" (change)="formRadio.controls['countryId'].setValue('');"> RUT <br>
                            </label><br>
                            <label style="cursor:pointer;">
                                <input class="form-check-input" type="radio" formControlName="document" value="passportNumber" id="passportNumber" style="cursor:pointer" > {{'ExceptionAccessPortal.labelPassport' | translate}}
                            </label>
                            <label><mat-error *ngIf="formRadio.controls['document'].hasError('required') && radioPress"> {{'ExceptionAccessPortal.labelDocumentType' | translate}} </mat-error></label>

                        </div>

                        <div class="col-md-2">
                            <select name="country" class="o-form__select" required style="cursor:pointer" formControlName="countryId"  required title="{{ 'ExceptionAccessPortal.selCountry' | translate}}">
                            <option [value]="''" disabled selected>{{ 'ExceptionAccessPortal.selCountry' | translate}}</option>
                            <option [value]="country.name" *ngFor="let country of selectCountry"> <span *ngIf="getlang()==='es'">{{country.nameEs}}</span> <span *ngIf="getlang()==='en'">{{country.name}}</span></option>
                            </select>
                        </div>

                        <div class="col-md-3 col-md-offset-0">

                            <div class="o-etable__addemployee">

                                <input style="background-color: white;" class="o-form__input" formControlName="ID" type="text" placeholder="{{'ExceptionAccessPortal.placeholderPassport' | translate}}">


                            </div>
                            <mat-error *ngIf="formRadio.controls['ID'].hasError('required') && radioPress "> {{'ExceptionAccessPortal.RequiredRutpass' | translate}} </mat-error>
                        </div>
                        <div class="col-md-2"> <a (click)="add()" class="btn btn--primary"  id="clone-add_employee">{{'ExceptionAccessPortal.btnAdd' | translate}} </a></div>
                    </form>
                  </div>

                </div>


              </div>
            </div>
          </div>
          <div class="o-etable__group" style="padding-top: 10px;">
            <div *ngIf="controlSiteZoneCCError " style="width:100%; background-color: #F2F0E9" align="center">
              <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'ExceptionAccessPortal.enterPlaces' | translate}}</mat-error></h5></span>
          </div>
            <div *ngIf="controlRepeatPerson" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'ExceptionAccessPortal.personEntered' | translate}}</mat-error></h5></span>
            </div>
            <div *ngIf="controlCountryError && formRadio.controls['countryId'].hasError('required') " style="width:100%; background-color: #F2F0E9" align="center">
              <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'ExceptionAccessPortal.countryNotEntered' | translate}}</mat-error></h5></span>
          </div>
            <div *ngIf="controlNotFoundError" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'ExceptionAccessPortal.personNotFound' | translate}}</mat-error></h5></span>
            </div>
            <div *ngIf="controlPeopleInError" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'ExceptionAccessPortal.warnOneReg' | translate}}</mat-error></h5></span>
            </div>
        </div>

          <div class="row">
             <div class="col-md-12 u-pt20">
                <div class="o-form__checkbox u-mb20">
                    <input type="checkbox" value="value" formControlName="Confirm" name="Confirm" required><span></span>
                    <a class="open_modal js-txt34" (click)="openDialog()" data="terms" style="cursor:pointer">{{'ExceptionAccessPortal.confirm' | translate}}</a>
                </div>
                 <div align="center" *ngIf="formAccessEmployee.controls['Confirm'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-0">
                    <h5 style="padding: 15px;"><i class="icon icon-close"></i> <mat-error style=" white-space: normal;">  {{ 'ExceptionAccessPortal.confirmTerms' | translate}}</mat-error></h5>
                </div>

                <br>
            </div>
            <div class="col-md-12 u-pt50">
              <span class="btn js-txt46" [routerLink]="['/']">{{ 'ExceptionAccessPortal.btnCancel' | translate}}</span>
              <button *ngIf="buttonEnable" class="btn btn--primary js-txt47" (click)="onSubmit()">{{ 'ExceptionAccessPortal.btnGenerate' | translate}}</button>

            </div>
          </div>
        </form>

      </div>
